import React from 'react'
import { Link } from 'react-router-dom'

export default function SharedPageFooter() {
  return (
    <footer className="border-t-[3px] border-ink mt-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-sm text-muted">
          This log is kept with <span className="font-bold text-ink">MyWrenchLog</span>, a free maintenance log for any vehicle.
        </p>
        <Link
          to="/get-started"
          className="inline-block text-center px-5 py-2.5 text-sm font-bold text-white bg-accent hover:bg-accent-dark shrink-0"
        >
          Start your own log
        </Link>
      </div>
      <div className="border-t border-line py-4">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 flex items-center justify-between gap-2 text-xs text-muted">
          <Link to="/privacy" className="hover:text-ink">Privacy</Link>
          <p>&copy; {new Date().getFullYear()} MyWrenchLog</p>
        </div>
      </div>
    </footer>
  )
}
